<template>
  <div class="page-container">
    <div class="page-header">
      <div>
        <h2 class="page-title">登录日志</h2>
      </div>
      <div class="page-header-extra">
        <span>失败 <b style="color:#f56c6c">{{ failTotal }}</b> 次</span>
      </div>
    </div>

    <el-card class="search-card" shadow="never">
      <el-form :inline="true" :model="query" size="small">
        <el-form-item label="登录账号">
          <el-input v-model="query.username" placeholder="账号关键字" clearable style="width: 150px" @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item label="登录IP">
          <el-input v-model="query.ip" placeholder="IP" clearable style="width: 140px" @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item label="结果">
          <el-select v-model="query.result" placeholder="全部" clearable style="width: 110px">
            <el-option label="成功" :value="1" />
            <el-option label="失败" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card" shadow="never">
      <el-table v-loading="loading" :data="list" border size="small" height="100%">
        <el-table-column prop="username" label="登录账号" width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.username }}</span>
            <el-tag v-if="scope.row.admin_id === 0" size="mini" type="info" effect="plain" style="margin-left:6px">不存在</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ip" label="登录IP" width="130"/>
        <el-table-column prop="ip_location" label="归属地" width="120"/>
        <el-table-column prop="browser" label="浏览器" width="130"/>
        <el-table-column prop="os" label="操作系统" width="120"/>
        <el-table-column label="结果" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.result === 1 ? 'success' : 'danger'" size="mini" effect="plain">
              {{ scope.row.result === 1 ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="失败原因" min-width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.fail_reason" style="color:#f56c6c">{{ scope.row.fail_reason }}</span>
            <span v-else class="cell-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="登录时间" width="150"/>
      </el-table>

      <div class="pagination-wrap">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          layout="total, prev, pager, next"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getLoginLogList } from '@/api/log'

export default {
  name: 'LoginLog',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      failTotal: 0,
      query: { username: '', ip: '', result: '' },
      page: 1,
      pageSize: 10
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    // 列表（后端已做 username/ip 模糊 + result 精确筛选，并分页）
    loadData() {
      this.loading = true
      const params = { page: this.page, page_size: this.pageSize }
      const username = (this.query.username || '').trim()
      if (username) params.username = username
      const ip = (this.query.ip || '').trim()
      if (ip) params.ip = ip
      if (this.query.result !== '' && this.query.result !== null) params.result = this.query.result
      getLoginLogList(params).then(res => {
        const data = res.data || {}
        this.list = data.list || []
        this.total = data.total || 0
        this.failTotal = data.fail_total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.page = 1
      this.loadData()
    },
    handlePageChange(val) {
      this.page = val
      this.loadData()
    },
    resetSearch() {
      this.query = { username: '', ip: '', result: '' }
      this.page = 1
      this.loadData()
    }
  }
}
</script>
